<template>
  <div>
    <div class="page-content">
      <div class="container">
        <div class="card content-area">
          <div class="card-innr">
            <div
              class="card-head d-flex justify-content-between align-items-center"
            >
              <h4 class="card-title mb-0">KYC Details</h4>
              <div class="d-flex align-items-center guttar-20px">
                <!-- <div class="flex-col d-sm-block d-none">
                  <a href="kyc-list.html" class="btn btn-sm btn-auto btn-primary">
                    <em class="fas fa-arrow-left mr-3"></em>Back
                  </a>
                </div>-->
                <!-- <div class="flex-col d-sm-none">
                  <a href="kyc-list.html" class="btn btn-icon btn-sm btn-primary">
                    <em class="fas fa-arrow-left"></em>
                  </a>
                </div>
                <div class="relative d-inline-block">
                  <a href="#" class="btn btn-dark btn-sm btn-icon toggle-tigger">
                    <em class="ti ti-more-alt"></em>
                  </a>
                  <div class="toggle-class dropdown-content dropdown-content-top-left">
                    <ul class="dropdown-list">
                      <li>
                        <a href="#">
                          <em class="ti ti-check"></em> Approve
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <em class="ti ti-na"></em> Cancel
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <em class="ti ti-trash"></em> Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>-->
              </div>
            </div>
            <div class="gaps-1-5x"></div>
            <div
              class="data-details d-md-flex flex-wrap align-items-center justify-content-between"
            >
              <!-- <div class="fake-class">
                <span class="data-details-title">Submited By</span>
                <span class="data-details-info">UD102001</span>
              </div>
              <div class="fake-class">
                <span class="data-details-title">Submited On</span>
                <span class="data-details-info">2018-08-24 10:12PM</span>
              </div>
              <div class="fake-class">
                <span class="data-details-title">Checked By</span>
                <span class="data-details-info">Admin</span>
              </div>
              <div class="fake-class">
                <span class="data-details-title">Checked On</span>
                <span class="data-details-info">2018-08-24 10:12PM</span>
              </div>
             
              <div class="gaps-2x w-100 d-none d-md-block"></div>
              <div class="w-100">
                <span class="data-details-title">Admin Note</span>
                <span class="data-details-info">Verified by phone call</span>
              </div>-->

              <div>
                <center>
                  <h5 style="font-weight:bold">Status</h5>
                  <span
                    style="width:200px;"
                    class="badge badge-md badge-success ucap"
                    >Approved</span
                  >
                </center>
              </div>
            </div>
            <div class="gaps-3x"></div>
            <h6 class="card-sub-title">Personal Information</h6>
            <ul class="data-details-list">
              <li>
                <div class="data-details-head">First Name</div>
                <div class="data-details-des">{{ this.userData.fname }}</div>
              </li>
              <!-- li -->
              <li>
                <div class="data-details-head">Last Name</div>
                <div class="data-details-des">{{ this.userData.lname }}</div>
              </li>
              <!-- li -->
              <li v-for="(email, index) in userData.emails" :key="index">
                <div v-if="email !== ''" class="data-details-head">
                  Email Address<span v-show="userData.emails.length > 1"
                    >({{ index + 1 }})</span
                  >
                </div>
                <div v-if="email !== ''" class="data-details-des">
                  {{ email }}
                </div>
              </li>
              <!-- li -->
              <li>
                <div class="data-details-head">Phone Number</div>
                <div class="data-details-des">{{ this.userData.mobile }}</div>
              </li>
              <!-- li -->
              <li>
                <div class="data-details-head">Date of Birth</div>
                <div class="data-details-des">{{ this.userData.bdate }}</div>
              </li>
              <!-- li -->
              <li>
                <div class="data-details-head">Full Address</div>
                <div class="data-details-des">{{ this.userData.address }}</div>
              </li>
              <!-- li -->
              <li>
                <div class="data-details-head">Country of Residence</div>
                <div class="data-details-des">{{ this.userData.country }}</div>
              </li>
              <li>
                <div class="data-details-head">KYC ID</div>
                <div class="data-details-des">{{ this.userData.kycId }}</div>
              </li>
              <!-- li -->

              <!-- li -->
            </ul>
            <div class="gaps-3x"></div>
            <h6 class="card-sub-title">Uploaded Documnets</h6>
            <ul class="data-details-list">
              <li>
                <div class="data-details-head">
                  ID Type:
                  <br />
                  <span style="color:#495463">{{ this.userData.idType }}</span>
                </div>

                <div class="data-details-head">
                  ID Number:
                  <br />
                  <span style="color:#495463">{{
                    this.userData.idNumber
                  }}</span>
                </div>
                <ul
                  style="text-align:center"
                  v-if="userData.idType == 'Passport'"
                  class="data-details-docs"
                >
                  <li>
                    <span class="data-details-docs-title">Document Image</span>
                    <div class="data-doc-item data-doc-item-lg">
                      <div
                        style="max-height:100vh;width:auto;overflow:auto;"
                        class="data-doc-image"
                      >
                        <img
                         
                          :src="userData.images[0]"
                          v-if="userData.images[0]"
                          @error="imgErrorPass"
                          alt="Please wait"
                        />
                        <img v-else src="../assets/loading.gif" />
                      </div>
                      <!-- <ul class="data-doc-actions">
                        <li>
                          <a href="#">
                            <em class="ti ti-import"></em>
                          </a>
                        </li>
                      </ul>-->
                    </div>
                  </li>

                  <!-- li -->
                  <!-- <li>
                    <span class="data-details-docs-title">Back Side</span>
                    <div class="data-doc-item data-doc-item-lg">
                      <div class="data-doc-image">
                        <img src="../assets/images/passport-a-back.jpg" alt="passport">
                      </div>
                      <ul class="data-doc-actions">
                        <li>
                          <a href="#">
                            <em class="ti ti-import"></em>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>-->
                  <!-- li -->
                </ul>

                <ul
                  v-else-if="userData.idType == 'National ID'"
                  style="text-align:center"
                  class="data-details-docs"
                >
                  <li>
                    <span class="data-details-docs-title">Front Side</span>
                    <div class="data-doc-item data-doc-item-lg">
                      <div
                        style="max-height:100vh;,max-width:100vw;overflow:auto;"
                        class="data-doc-image"
                      >
                        <img
                          v-if="userData.images[0]"
                      
                          :src="userData.images[0]"
                          @error="imgErrorPass"
                        />
                        <img v-else src="../assets/loading.gif" />
                      </div>
                      <!-- <ul class="data-doc-actions">
                        <li>
                          <a href="#">
                            <em class="ti ti-import"></em>
                          </a>
                        </li>
                      </ul>-->
                    </div>
                  </li>

                  <!-- li -->
                  <li>
                    <span class="data-details-docs-title">Back Side</span>
                    <div class="data-doc-item data-doc-item-lg">
                      <div
                        style="max-height:100vh;max-width:100vw;overflow:auto;"
                        class="data-doc-image"
                      >
                        <img
                          v-if="userData.images[1]"
                         
                          :src="userData.images[1]"
                        />
                        <img v-else src="../assets/loading.gif" />
                      </div>
                      <!-- <ul class="data-doc-actions">
                        <li>
                          <a href="#">
                            <em class="ti ti-import"></em>
                          </a>
                        </li>
                      </ul>-->
                    </div>
                  </li>
                  <!-- li -->
                </ul>

                <ul style="text-align:center" v-else class="data-details-docs">
                  <li>
                    <span class="data-details-docs-title">Document Image</span>
                    <div class="data-doc-item data-doc-item-lg">
                      <div
                       style="max-height:100vh;max-width:vw;overflow:auto;"
                        class="data-doc-image"
                      >
                        <img
                        
                          :src="userData.images[0]"
                          v-if="userData.images[0]"
                          @error="imgErrorPass"
                          alt="Please wait"
                        />
                        <img v-else src="../assets/loading.gif" />
                      </div>
                      <!-- <ul class="data-doc-actions">
                        <li>
                          <a href="#">
                            <em class="ti ti-import"></em>
                          </a>
                        </li>
                      </ul>-->
                    </div>
                  </li>

                  <!-- li -->

                  <!-- li -->
                </ul>
              </li>
              <!-- li -->
            </ul>


              <h6 class="card-sub-title mt-3">Uploaded Selfie</h6>
            <ul class="data-details-list">
              <li>
                <div class="data-details-head">
                  DOC Type:
                  <br />
                  <span style="color:#495463">User's selfie with a random security code </span>
                </div>
                 <div class="data-details-head">
                  Random security code:
                  <br />
                  <span style="color:#495463">{{
                    this.userData.randomNumber
                  }}</span>
                </div>
                
                <ul
                  style="text-align:center"
                  v-if="userData.idType == 'Passport'"
                  class="data-details-docs"
                >
                  <li>
                    <span class="data-details-docs-title">Document Image</span>
                    <div class="data-doc-item data-doc-item-lg">
                      <div
                      style="max-height:100vh;max-width:vw;overflow:auto;"
                        class="data-doc-image"
                      >
                        <img
                      
                          :src="userData.images[1]"
                          v-if="userData.images[1]"
                          @error="imgErrorPass"
                          alt="Please wait"
                        />
                        <img v-else src="../assets/loading.gif" />
                      </div>
                      <!-- <ul class="data-doc-actions">
                        <li>
                          <a href="#">
                            <em class="ti ti-import"></em>
                          </a>
                        </li>
                      </ul>-->
                    </div>
                  </li>

                  <!-- li -->
                  <!-- <li>
                    <span class="data-details-docs-title">Back Side</span>
                    <div class="data-doc-item data-doc-item-lg">
                      <div class="data-doc-image">
                        <img src="../assets/images/passport-a-back.jpg" alt="passport">
                      </div>
                      <ul class="data-doc-actions">
                        <li>
                          <a href="#">
                            <em class="ti ti-import"></em>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>-->
                  <!-- li -->
                </ul>

                <ul
                  v-else-if="userData.idType == 'National ID'"
                  style="text-align:center"
                  class="data-details-docs"
                >
                  

                  <!-- li -->
                  <li>
                    <span class="data-details-docs-title">Document Image</span>
                    <div class="data-doc-item data-doc-item-lg">
                      <div
                     style="max-height:100vh;max-width:100vw;overflow:auto;"
                        class="data-doc-image"
                      >
                        <img
                          v-if="userData.images[2]"
                   
                          :src="userData.images[2]"
                          @error="imgErrorNational1"
                        />
                        <img v-else src="../assets/loading.gif" />
                      </div>
                      <!-- <ul class="data-doc-actions">
                        <li>
                          <a href="#">
                            <em class="ti ti-import"></em>
                          </a>
                        </li>
                      </ul>-->
                    </div>
                  </li>
                  <!-- li -->
                </ul>

                <ul style="text-align:center" v-else class="data-details-docs">
                  <li>
                    <span class="data-details-docs-title">Document Image</span>
                    <div class="data-doc-item data-doc-item-lg">
                      <div
                     style="max-height:100vh;max-width:vw;overflow:auto;"
                        class="data-doc-image"
                      >
                        <img
                         
                          v-if="userData.images[1]"
                          :src="userData.images[1]"
                          @error="imgErrorPass"
                          alt="Please wait"
                        />
                        <img v-else src="../assets/loading.gif" />
                      </div>
                      <!-- <ul class="data-doc-actions">
                        <li>
                          <a href="#">
                            <em class="ti ti-import"></em>
                          </a>
                        </li>
                      </ul>-->
                    </div>
                  </li>

                  <!-- li -->

                  <!-- li -->
                </ul>
               
              </li>
              <!-- li -->
            </ul>
          </div>
          <!-- .card-innr -->
        </div>
        <!-- .card -->
      </div>
      <!-- .container -->
    </div>
    <!-- .page-content -->
  </div>
</template>
<script>
import axios from "axios";
import image from "../assets/loading.gif";


export default {
  name: "PersonalDetailsGov",
  data() {
    return {
      UsersData: undefined,
      currentAddress: this.$cookies.get("address"),
    };
  },
  asyncComputed: {
    async userData() {
      return this.UsersData;
    },
  },
  methods: {
    imgErrorPass(e) {
      e.target.src = image;
    },
    imgErrorNational1(e){
     
      e.target.src=image
        
    },
     async getData() {
      this.$store.state.loading = true;
      try{
      let personalData = await this.$store.state.KYC
        .getPersonalUserDetails(this.$route.params.userAddress)
        .call({ from: this.currentAddress });
        console.log(personalData)
        

     

      let emailLen = await this.$store.state.KYC
        .getEmailLength(this.$route.params.userAddress)
        .call({ from: this.currentAddress });

      let Emails = [];
      for (let i = 0; i < emailLen; i++) {
        let email = await this.$store.state.KYC
          .getEmailUser(this.$route.params.userAddress, i)
          .call({ from: this.currentAddress });
        Emails.push(email.email);
      }
      let key = process.env.VUE_APP_API_KEY;
        let getData = await axios({
        url: this.$store.state.url+"/api/user/getEmail",

          method: "POST",
          data: {
            emails: Emails
          },
          headers: {
            Authorization: "Basic " + key
          }
        });

        let emails = [...new Set(getData.data.Emails)];



      
     

      try {
        let data = await axios({
          url: this.$store.state.url + "/api/user/getKycData",
          method: "POST",
          data:{
            hash:personalData.hash
          },

          headers: {
            Authorization: "Basic " + key,
          },
        });
       data.data.emails=emails
       console.log(data)
        this.userData=data.data
       // this.$cookies.set('name',data.data.fname+" "+data.data.lname,0)
         this.$cookies.set('idType',data.data.idType,0)
       // this.$store.dispatch('getName',data.data.fname+" "+data.data.lname)
    

      }
      catch(err){
        console.log(err)
      }
      }
      catch(err){
        console.log(err)
      }
    
    
          let key = process.env.VUE_APP_API_KEY;
          let images=[]
           for (let i = 0; i < this.userData.images.length; i++) {
        
          try {
            let img = await axios({
              url:this.$store.state.url+"/api/user/getDocImage/"+this.userData.images[i],
              method:"GET",
              headers: {
              Authorization: "Basic " + key,
            },
              responseType: 'arraybuffer'
          
            
            });
          images.push(img.data)
              
        
        } catch (err) {
          console.log(err);
        }
      }
      this.userData.images=images;
    

   
  
         var arrayBufferView1 = new Uint8Array( this.userData.images[0] );
        var blob1 = new Blob( [ arrayBufferView1 ], { type: "image/jpeg" } );
        var urlCreator1 = window.URL || window.webkitURL;
        var imageUrl1 = urlCreator1.createObjectURL( blob1 );
        this.userData.images[0]=imageUrl1

         var arrayBufferView2 = new Uint8Array( this.userData.images[1] );
        var blob2 = new Blob( [ arrayBufferView2 ], { type: "image/jpeg" } );
        var urlCreator2 = window.URL || window.webkitURL;
        var imageUrl2 = urlCreator2.createObjectURL( blob2 );
        this.userData.images[1]=imageUrl2

          if(this.userData.idType=="National ID"){
             var arrayBufferView2 = new Uint8Array( this.userData.images[2] );
        var blob2 = new Blob( [ arrayBufferView2 ], { type: "image/jpeg" } );
        var urlCreator2 = window.URL || window.webkitURL;
        var imageUrl2 = urlCreator2.createObjectURL( blob2 );
        this.userData.images[2]=imageUrl2
          }


    
     
    
      this.$store.state.loading = false;
    }
    
  
   
  },
  async mounted(){
      
      
  },
  async created() {
    await this.getData();
    // await this.getImages();
  },
  beforeCreate() {},
};
</script>
<style scoped>
@import "../assets/css/vendor.bundle.css?ver=104";
@import "../assets/css/style.css?ver=104";
</style>
